import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    TextField, Stack, Typography, Box, IconButton
} from '@mui/material';
import { Close, Download } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ServiceAgreementPDF from './ServiceAgreementPDF';

const ManualAgreementModal = ({ open, onClose }) => {
    const [form, setForm] = useState({ name: '', address: '' });

    const handleClear = () => {
        setForm({ name: '', address: '' });
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="bold">Manual Service Agreement</Typography>
                    <IconButton onClick={onClose} size="small"><Close /></IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Enter the details below to generate a professional Service Agreement PDF for a school not
                    yet registered in the system.
                </Typography>

                <Stack spacing={3}>
                    <TextField
                        label="School Name"
                        fullWidth
                        required
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        placeholder="e.g. Royal Academy"
                    />
                    <TextField
                        label="School Address"
                        fullWidth
                        required
                        multiline
                        rows={2}
                        value={form.address}
                        onChange={(e) => setForm({ ...form, address: e.target.value })}
                        placeholder="e.g. Plot 42, Kumasi High St, Ghana"
                    />
                </Stack>
            </DialogContent>
            <DialogActions sx={{ p: 2, justifyContent: 'space-between' }}>
                <Button onClick={handleClear} color="inherit">Cancel</Button>

                {form.name && form.address ? (
                    <PDFDownloadLink
                        document={<ServiceAgreementPDF school={{ name: form.name, address: form.address }} />}
                        fileName={`Agreement_${form.name.replace(/\s+/g, '_')}.pdf`}
                        style={{ textDecoration: 'none' }}
                    >
                        {({ loading }) => (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<Download />}
                                disabled={loading}
                            >
                                {loading ? 'Preparing...' : 'Download Agreement'}
                            </Button>
                        )}
                    </PDFDownloadLink>
                ) : (
                    <Button variant="contained" disabled startIcon={<Download />}>
                        Download Agreement
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ManualAgreementModal;
